import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Vault, DocumentVault } from './pages';

export const VaultPage = () => {
  return (
    <Routes>
      <Route path="/" element={<Vault />} />
      <Route path="documents" element={<DocumentVault />} />
    </Routes>
  );
};

export default VaultPage;
